import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";

import { FaProjectDiagram, FaServer, FaCloud, FaDatabase, FaNetworkWired, FaCogs, FaShieldAlt, FaChartLine } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const serviceCards = [
    {
        icon: <FaProjectDiagram size={80} color="var(--brand-primary)" />,
        title: "Enterprise Architecture Design",
        description: "Comprehensive architecture blueprints for complex enterprise systems. We design scalable, maintainable architectures that align technology with business objectives and support long-term growth.",
    },
    {
        icon: <FaCloud size={80} color="var(--brand-primary)" />,
        title: "Cloud Architecture",
        description: "Modern cloud-native architectures leveraging AWS, Azure, or Google Cloud. We design for high availability, disaster recovery, cost optimization, and multi-region deployment.",
    },
    {
        icon: <FaServer size={80} color="var(--brand-primary)" />,
        title: "Microservices Architecture",
        description: "Decompose monoliths into scalable microservices with clear boundaries and responsibilities. We design service communication patterns, API gateways, and service mesh implementations.",
    },
    {
        icon: <FaDatabase size={80} color="var(--brand-primary)" />,
        title: "Data Architecture & Strategy",
        description: "Design robust data architectures including data lakes, warehouses, and real-time streaming. We ensure data consistency, integrity, and accessibility across your organization.",
    },
    {
        icon: <FaNetworkWired size={80} color="var(--brand-primary)" />,
        title: "Integration Architecture",
        description: "Design seamless integration patterns for connecting systems, services, and third-party platforms. We implement event-driven architectures, message queues, and API management strategies.",
    },
    {
        icon: <FaShieldAlt size={80} color="var(--brand-primary)" />,
        title: "Security Architecture",
        description: "Build security into your architecture from the ground up. We design zero-trust architectures, implement defense-in-depth strategies, and ensure compliance with security standards.",
    },
    {
        icon: <FaChartLine size={80} color="var(--brand-primary)" />,
        title: "Scalability & Performance Design",
        description: "Architect systems that scale horizontally and vertically to handle growth. We design for performance, implementing caching strategies, load balancing, and auto-scaling mechanisms.",
    },
    {
        icon: <FaCogs size={80} color="var(--brand-primary)" />,
        title: "Technology Stack Selection",
        description: "Choose the right technologies, frameworks, and tools for your specific needs. We evaluate options based on performance, maintainability, team expertise, and long-term viability.",
    },
];

const SystemArchitectureSolutionDesign = () => {
    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>System Architecture & Solution Design - Syrol Tech</title>
                <meta name="description" content="We design robust, scalable system architectures that support performance, security, and future growth—ensuring the right technical foundations from day one." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="System Architecture & Solution Design"
                pageName="System Architecture & Solution Design"
                breadcrumbsImg={bannerbg}
            />
            <section className="consultation-hero-section position-relative w-100" style={{ minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat` }}>
                <div className="hero-overlay" style={{ position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left' }}>
                    <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem' }}>Build the right technical foundation from day one</h1>
                    <p style={{ color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem' }}>We design robust, scalable system architectures that support performance, security, and future growth—ensuring the right technical foundations from day one.</p>
                    <Link to="/consultation" className="readon orange-btn" style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s' }}>Request A Free Proposal</Link>
                </div>
            </section>
            <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
                <div className="container pb-66 md-pb-46">
                    <h2 className="service-title mb-32">Our System Architecture & Solution Design Services</h2>
                    {serviceCards.map((card, idx) => (
                        <ServiceCard
                            key={idx}
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                        />
                    ))}
                </div>
            </div>
            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />
        </React.Fragment>
    );
};

export default SystemArchitectureSolutionDesign;
